<div class="nav-item" style="height: 100%" ngbDropdown #languageRef="ngbDropdown">
  <a class="nav-link" ngbDropdownToggle id="languageDropdown" role="button">
    <img [src]="selectedLang.flag" class="wd-20 me-1" [attr.title]="selectedLang.name" [attr.alt]="selectedLang.name" />
    <span class="fw-bold ms-1 me-1 d-none d-md-inline-block" [class]="selectedLang.class">{{ selectedLang.name }}</span>
  </a>
  <div ngbDropdownMenu aria-labelledby="languageDropdown" class="languageDropdown">
    <a ngbDropdownItem class="py-2" *ngFor="let lang of languages" (click)="changeCurrentLang(lang)" role="button">
      <img [src]="lang['info']['flag']" class="wd-20 me-1" [attr.title]="lang['info']['name']"
        [attr.alt]="lang['info']['name']" />
      <span class="wd-20 me-1" [class]="lang['info']['class']"> {{ lang['info']['name'] }} </span></a>
  </div>
</div>
